import React from 'react';
import mishary from '../../assets/images/mish-2.jpg';

const About = () => {
    return (
        <div className='container section about-section'>
            <h2 className='title'>A little about me,</h2>
            <h1 className='title-bg'>ABOUT</h1>
            <div className='row'>
                <div className='col-lg-6'>
                    <p className='main-info about-info'>A tech enthusiast who loves to code and creates well-defined web-worlds in the browser. Proficient in mounting components with React JS and puts effort in writing clean and readable code.</p>
                </div>
                <div className='col-lg-6'>
                    <img className='w-75 img-fluid img-thumbnail about-img' src={mishary} alt="" />
                </div>
            </div>
        </div>
    );
};

export default About;